let url = () =>{
    let url
    if(process.env.NODE_ENV === 'development') {
        // url = `http://139.162.234.164:81`
        url = `https://staging.afcfta.app/api`
    } else {
        // url = `http://139.162.234.164:81`
          url = `https://staging.afcfta.app/api`
        // url = `https://main.afcfta.app/api`
    }
    return url
}

export default url;